import React from 'react';
import { Content } from '../../types/content';
import TopicCard from '../TopicCard';
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';
import LoadingSpinner from './LoadingSpinner';

interface ContentGridProps {
  items: Content[];
  loading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
  onLike?: (id: string) => void;
  onShare?: (id: string) => void;
}

export default function ContentGrid({
  items,
  loading = false,
  hasMore = false,
  onLoadMore,
  onLike,
  onShare
}: ContentGridProps) {
  const loadMoreRef = useInfiniteScroll(
    () => {
      if (onLoadMore && !loading && hasMore) {
        onLoadMore();
      }
    },
    { disabled: !hasMore || loading }
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(item => (
          <TopicCard
            key={item.id}
            topic={item}
            onLike={() => onLike?.(item.id)}
            onShare={() => onShare?.(item.id)}
          />
        ))}
      </div>
      
      {(loading || hasMore) && (
        <div ref={loadMoreRef} className="py-8">
          {loading && <LoadingSpinner />}
        </div>
      )}
    </div>
  );
}